import {
  React,
  Component,
  PropTypes,
  helpers
} from 'imports/CommonImports';

import {
  PrimaryColor1,
  SuccessColorLight,
  GreyColor1,
  GreyColor2,
  ShadowColor,
} from 'imports/DesignImports';


import ReactHighcharts from 'react-highcharts';

import {
  Paper,
} from 'material-ui';


const styles = {
  pageContainer: {
    padding: '0px 25px'
  },
}

class StackedAreaGraph extends Component {
  constructor(props){
    super(props);
    const years = props.years.map(year => year.year);
    const data = props.data.map(project => ({name: project.name, data: project.values}));
    this.state = {
      years,
      data,
      colors: [SuccessColorLight,  PrimaryColor1, GreyColor1],
    }
  }

  render() {
    return (
      <Paper style={{...styles.pageContainer, ...this.props.style}}>
        <p style={styles.header}><b>{this.props.header}</b></p>
        <ReactHighcharts config={this.config(this.state.extra)} ref="chart" style={{minHeight:"400px"}} />
      </Paper>
    );
  }

  config = (extra) => { return({
    chart: {
      type: 'area',
      backgroundColor: GreyColor2,
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: this.state.years,
        tickmarkPlacement: 'on',
        endOnTick: false,
        startOnTick: false,
        min: 0.5,
        max: 1.5,
        title: {
            enabled: false
        }
    },
    yAxis: {
        title: {
          text: `${this.props.indicator} (${this.props.currency})`,
        },
        labels: {
            formatter: function () {
                return (this.value / 1000000) + "M" ;
            }
        }
    },
    tooltip: {
        split: true,
        crosshairs: true,
        formatter: function () {
          return ['<b>' + this.x + '</b>'].concat(
              this.points.map(function (point) {
                  return point.series.name + ': ' + (point.y / 1000000).toFixed(3).replace('.',',') + 'M';
              })
          );
      },
    },
    plotOptions: {
        area: {
            stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
                lineWidth: 1,
                lineColor: '#666666'
            }
        }
    },
    series: this.state.data
  })}
}

StackedAreaGraph.propTypes = {
  style: PropTypes.object,
  data: PropTypes.array,
  header: PropTypes.string,
  indicator: PropTypes.string,
  currency: PropTypes.string,
};

StackedAreaGraph.defaultProps = {
  style: {},
  data: [{option: 'N/A', values: [0,1,2]}, {option: 'N/A', values: [0,1,2]}, {option: 'N/A', values: [0,1,2]}],
  header: 'Sin datos',
  indicator: 'EBITDA',
  currency: 'CLP'
};

export default StackedAreaGraph;



// WEBPACK FOOTER //
// ./src/components/dashboard/StackedAreaGraph.js